// extracted by mini-css-extract-plugin
export default {"first-class-discount-disabled-lesson-form":"first-class-discount-disabled-lesson-form_lmfQC"};